var _circle, _path, _circle2, _path2, _circle3, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavPlayersIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 28,
    viewBox: "0 0 49 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.2835,
    cy: 6.57855,
    r: 6.57853,
    fill: "current"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6537 13.305C15.4738 16.133 13.1362 21.2819 12.4384 27.4105H36.1286C35.4308 21.2819 33.0932 16.133 29.9132 13.305C28.3898 14.5814 26.4264 15.3499 24.2835 15.3499C22.1406 15.3499 20.1771 14.5814 18.6537 13.305Z",
    fill: "current"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.009,
    cy: 12.4864,
    r: 4.71291,
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9754 17.305C33.6971 19.3308 32.0223 23.0197 31.5223 27.4105H48.4942C47.9943 23.0202 46.3197 19.3316 44.0418 17.3056C42.9505 18.2198 41.544 18.7702 40.009 18.7702C38.4736 18.7702 37.0669 18.2196 35.9754 17.305Z",
    fill: "current"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.48665,
    cy: 12.4864,
    r: 4.71291,
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.45307 17.305C2.17477 19.3308 0.499924 23.0197 0 27.4105H16.9718C16.4719 23.0202 14.7974 19.3316 12.5195 17.3056C11.4281 18.2198 10.0217 18.7702 8.48666 18.7702C6.95128 18.7702 5.54451 18.2196 4.45307 17.305Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavPlayersIcon);
export default __webpack_public_path__ + "static/media/Nav-PlayersIcon.7ec60b1804bd78e9a29fab0ad0d08ccc.svg";
export { ForwardRef as ReactComponent };